import { useEffect } from 'react';
import uuid from 'uuid';
import TCClient from 'client';

type AlertCredentials = {
  orgToken: string;
  authKey: string;
  authSecret: string;
} | null;

export default function useClinicalWorkflowsMessaging(
  clinicalWorkflowsAlertUsers: AlertCredentials,
  currentOrganizationId: string
) {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const client = TCClient as any;

    const handleAscendMessage = async (event: MessageEvent) => {
      if (event.data?.source !== 'ascend') return;
      console.log('[Ascend postMessage]', event.data.type, event.data);

      if (!clinicalWorkflowsAlertUsers) {
        console.error('[Ascend] Missing alert credentials — skipping API call');
        return;
      }

      const currentUserId = client.currentUserId;

      if (event.data.type === 'simulation-started') {
        const payload = {
          ...event.data?.data,
          ...clinicalWorkflowsAlertUsers,
          organizationId: currentOrganizationId,
          recipientId: event.data?.data?.recipientId || currentUserId,
          messageId: event.data?.data?.messageId || uuid.v4(),
        };
        try {
          const result = await client.api.alertManager.send(payload);
          console.log('[Ascend] alertManager.send() success:', result);
        } catch (err) {
          console.error('[Ascend] alertManager.send() failed:', err);
        }
      }

      if (event.data.type === 'simulation-cancelled') {
        const payload = {
          ...event.data?.data,
          ...clinicalWorkflowsAlertUsers,
          organizationId: currentOrganizationId,
          recipientId: event.data?.data?.recipientId || currentUserId,
        };
        try {
          const result = await client.api.alertManager.cancel(payload);
          console.log('[Ascend] alertManager.cancel() success:', result);
        } catch (err) {
          console.error('[Ascend] alertManager.cancel() failed:', err);
        }
      }
    };
    window.addEventListener('message', handleAscendMessage);
    return () => {
      window.removeEventListener('message', handleAscendMessage);
    };
  }, [clinicalWorkflowsAlertUsers, currentOrganizationId]);
}
